import { createContext, useContext, useState, useCallback, useRef } from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogFooter,
  AlertDialogTitle, AlertDialogDescription,
} from "@/components/ui/alert-dialog";

const ConfirmContext = createContext(() => Promise.resolve(false));
export const useConfirm = () => useContext(ConfirmContext);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState({ open: false, opts: {} });
  const resolver = useRef(null);

  const confirm = useCallback((opts = {}) => new Promise((resolve) => {
    resolver.current = resolve;
    setState({ open: true, opts });
  }), []);

  const settle = (val) => {
    setState((s) => ({ ...s, open: false }));
    if (resolver.current) { resolver.current(val); resolver.current = null; }
  };

  const o = state.opts;
  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <AlertDialog open={state.open} onOpenChange={(v) => { if (!v) settle(false); }}>
        <AlertDialogContent data-testid="confirm-dialog" className="max-w-md">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-lg font-black text-[#1E3A8A]">{o.title || "Are you sure?"}</AlertDialogTitle>
            {o.description && <AlertDialogDescription className="text-[#6B7280]">{o.description}</AlertDialogDescription>}
          </AlertDialogHeader>
          <AlertDialogFooter>
            <button onClick={() => settle(false)} data-testid="confirm-cancel"
              className="h-11 px-4 rounded-lg border border-[#D1D5DB] bg-white font-bold text-sm text-[#374151] mt-2 sm:mt-0">
              {o.cancelText || "Cancel"}
            </button>
            <button onClick={() => settle(true)} data-testid="confirm-ok"
              className={`h-11 px-4 rounded-lg text-white font-bold text-sm ${o.destructive ? "bg-[#B91C1C] hover:bg-[#991B1B]" : "bg-[#1E3A8A] hover:bg-[#375DBA]"}`}>
              {o.confirmText || "Confirm"}
            </button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </ConfirmContext.Provider>
  );
}
